const styles = {
    abcBox: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "8px",
      padding: "10px",
    },
  
    btnAllCitiesBox: {
      display: "flex",
      justifyContent: "center",
      marginTop: "20px",
    },
  
    getNeonButton: (theme) => {
      const isDark = theme.palette.mode === "dark";
      const neonColor = isDark ? "#0ff" : "#6dcff6"; // Голубоватый в светлой теме
      const bgColor = isDark ? "#111" : "#fff"; // В светлой теме фон теперь тёмно-серый
      const textColor = isDark ? "#fff" : "#333"; // В светлой теме фон теперь тёмно-серый
  
      return {
        position: "relative",
        padding: "12px 18px",
        fontSize: "18px",
        textTransform: "uppercase",
        fontWeight: "bold",
        cursor: "pointer",
        transition: "0.3s",
        color: textColor,
        background: bgColor,
        border: "none",
        borderRadius: "8px",
        overflow: "hidden",
        
        boxShadow: `0 0 5px ${neonColor}`,
        
        "&:hover": {
          background: neonColor,
          color: "#333",
          boxShadow: `0 0 20px ${neonColor}, 0 0 40px ${neonColor}`,
        },
  
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderRadius: "8px",
          border: `2px solid ${neonColor}`,
          opacity: 0,
          transition: "opacity 0.3s",
        },
  
        "&:hover::after": {
          opacity: 1,
          animation: "neon-glow 1.5s linear infinite",
        },
  
        "@keyframes neon-glow": {
          "0%": { transform: "translateX(-100%)" },
          "50%": { transform: "translateX(100%)" },
          "100%": { transform: "translateX(-100%)" },
        },
      };
    },
  
    
  };
  
  export default styles;
  